import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import DocUploadWithPrgress from 'components/global/upload/DocUploadWithPrgress'
import React, { useState } from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'

const RulesAndregulationModal: React.FC = () => {
  const {
    rulesAndRegulationModal,
    setRulesAndRegulationModal,
    rulesAndRegulation,
    setRulesAndRegulation,
  } = leagueEventStore(store => ({
    rulesAndRegulationModal: store.rulesAndRegulationModal,
    setRulesAndRegulationModal: store.setRulesAndRegulationModal,
    rulesAndRegulation: store.rulesAndRegulation,
    setRulesAndRegulation: store.setRulesAndRegulation,
  }))
  const [documentIds, setDocumentIds] = useState<string[]>([])

  const handleClose = () => {
    setRulesAndRegulationModal(false)
  }

  const handleSubmit = () => {
    setRulesAndRegulation([...rulesAndRegulation, ...documentIds])
    handleClose()
  }

  return (
    <>
      <CustomModal
        openModal={rulesAndRegulationModal}
        isCloseModalCustom={true}
        closeModal={handleClose}
        title="Rules and Regulations"
        width={600}
        footer={
          <CustomModalFooter
            multibutton={false}
            btnText="Save"
            btnAlignment="justify-end"
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <p>
          Add the rules and regulations that parents will see on the website.
        </p>

        <DocUploadWithPrgress
          documentIds={documentIds}
          setDocumentIds={setDocumentIds}
        />
      </CustomModal>
    </>
  )
}

export default RulesAndregulationModal
